// extracted by css-extract-rspack-plugin
export default {"EnterPhoneNumberModal-prompt":"sputnik__EnterPhoneNumberModal-prompt__CnJpF","enterPhoneNumberModalPrompt":"sputnik__EnterPhoneNumberModal-prompt__CnJpF"};